import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M17,11V2H7A2.006,2.006,0,0,0,5,4V28a2.006,2.006,0,0,0,2,2H25a2.006,2.006,0,0,0,2-2V12H18A1,1,0,0,1,17,11ZM8,16a2,2,0,0,1,2-2h1a2,2,0,1,1,2-2,2,2,0,0,1-2,2h1a2,2,0,0,1,2,2v1a1,1,0,0,1-2,0V16H10v1a1,1,0,0,1-2,0Zm8,10H9a1,1,0,0,1,0-2h7a1,1,0,0,1,0,2Zm0-4H9a1,1,0,0,1,0-2h7a1,1,0,0,1,0,2Zm5-6h2a1,1,0,0,1,0,2H21a1,1,0,0,1,0-2Zm0,4h2a1,1,0,0,1,0,2H21a1,1,0,0,1,0-2Zm0,4h2a1,1,0,0,1,0,2H21a1,1,0,0,1,0-2Z"/><path d="M26,8.59l-.29-.3-5-5L20.41,3A3.443,3.443,0,0,0,19,2.19V10h7.81A3.443,3.443,0,0,0,26,8.59Z"/>';
export var ProfileSVG = function ProfileSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ProfileSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ProfileSVG);